import type { ReactNode } from 'react';
import type { Scope } from '../../types';
import { VisibilityChip } from '../primitives';

interface Props {
  title: string;
  kicker?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  scope?: Scope;
}

export function PageHeader({ title, kicker, meta, actions, scope }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        marginBottom: 26,
        gap: 24,
      }}
    >
      <div style={{ minWidth: 0 }}>
        {kicker && (
          <div
            style={{
              fontSize: 12,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: 'var(--slate)',
              fontWeight: 600,
              marginBottom: 6,
              display: 'flex',
              alignItems: 'center',
              gap: 10,
            }}
          >
            {kicker}
            {scope && <VisibilityChip scope={scope} size="sm" />}
          </div>
        )}
        <h1
          style={{
            margin: 0,
            fontSize: 44,
            fontWeight: 800,
            letterSpacing: '-0.035em',
            color: 'var(--deep)',
            lineHeight: 1.05,
          }}
        >
          {title}
        </h1>
        {meta && (
          <div
            style={{
              marginTop: 10,
              color: 'var(--slate)',
              fontSize: 14,
              display: 'flex',
              gap: 18,
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            {meta}
          </div>
        )}
      </div>
      {actions && (
        <div style={{ display: 'flex', gap: 10, flexShrink: 0 }}>
          {actions}
        </div>
      )}
    </div>
  );
}
